module.exports = __webpack_public_path__ + "media/images/beach-umbrella-d496280b8886e5b5e8f5b3101d6ff2ce.png";